import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { UserCostCenter, UserCostCentersWithErrors } from "./types";

export const useCostCentersApi = () => {
  const api = useApi();

  const getAdminUserCostCenters = useCallback(
    (userId: string, hasPermission: boolean) => {
      const url = `/admin/users/${userId}/cost_centers`;

      const key = hasPermission === false ? false : url;

      return useSWRMutation<UserCostCentersWithErrors, CustomError, string | null>(
        key as string | null,
        (url: string) => api.get<UserCostCentersWithErrors>({ url }),
      );
    },
    [api],
  );

  const upsertAdminUserCostCenters = useCallback(
    async (userId: string, body: UserCostCenter[]) => {
      const url = `/admin/users/${userId}/cost_centers`;
      await api.put<UserCostCenter[]>(url, body).then(() => {
        api.mutateCache([url, `/admin/users/`]);
      });
    },
    [api],
  );

  // const useUserCostCentersCountErrors = useCallback(
  //   (signal: AbortSignal, active: boolean) => {
  //     const url = active ? "/admin/user-cost-centers/import-errors/count" : null;
  //     return useSWR<UserCostCentersCountResponse | null, CustomError, string | null>(url, (url) =>
  //       api.get<UserCostCentersCountResponse>({ url, signal }),
  //     );
  //   },
  //   [api],
  // );

  return {
    getAdminUserCostCenters,
    upsertAdminUserCostCenters,
    // useUserCostCentersCountErrors,
  };
};
